import { useContext } from 'react';
import { PhoneContext, type PhoneContextValue } from './phoneContext';

/**
 * Телефон, если он вообще смонтирован.
 *
 * Блок статуса живёт в общем каркасе админки, а каркас рендерят и там, где
 * телефона нет вовсе (тесты чужих экранов, будущие внешние страницы). Падать
 * в таком месте нельзя: отсутствие телефона — это «линия не подключена», а не
 * поломка страницы.
 */
export function useOptionalPhone(): PhoneContextValue | null {
  return useContext(PhoneContext);
}

/** Телефон оператора: соединение живёт над маршрутами, экраны только пользуются. */
export function usePhone(): PhoneContextValue {
  const value = useContext(PhoneContext);

  if (value === null) {
    throw new Error('usePhone вызван вне PhoneProvider — телефон живёт над маршрутами.');
  }

  return value;
}
